import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import { webhookEndpointsQueryOptions } from "./webhooks.queries";
import type {
	QueuedWebhookDelivery,
	WebhookEndpoint,
	WebhookEndpointChange,
	WebhookEndpointWithSecret,
	WebhookEventType,
	WebhookRunKind,
} from "./webhooks.types";

// Every webhook query key starts with "webhooks", so one prefix refreshes the list and every log.
const invalidate = () =>
	queryClient.invalidateQueries({ queryKey: webhookEndpointsQueryOptions.queryKey });

export const createEndpointMutation = mutationOptions({
	mutationFn: (vars: {
		url: string;
		description?: string;
		eventTypes: WebhookEventType[];
		runKinds: WebhookRunKind[] | null;
	}) => api.post<WebhookEndpointWithSecret>("/platform/webhooks", vars),
	onSuccess: invalidate,
});

export const updateEndpointMutation = mutationOptions({
	mutationFn: ({ id, ...change }: WebhookEndpointChange & { id: string }) =>
		api.patch<WebhookEndpoint>(`/platform/webhooks/${id}`, change),
	onSuccess: invalidate,
});

export const deleteEndpointMutation = mutationOptions({
	mutationFn: (id: string) => api.del(`/platform/webhooks/${id}`),
	onSuccess: invalidate,
});

export const rotateSecretMutation = mutationOptions({
	mutationFn: (vars: { id: string; expiresInHours: number }) =>
		api.post<WebhookEndpointWithSecret>(`/platform/webhooks/${vars.id}/rotate-secret`, {
			expiresInHours: vars.expiresInHours,
		}),
	onSuccess: invalidate,
});

export const sendTestMutation = mutationOptions({
	mutationFn: (id: string) => api.post<QueuedWebhookDelivery>(`/platform/webhooks/${id}/test`),
	onSuccess: invalidate,
});

export const redeliverMutation = mutationOptions({
	mutationFn: (vars: { endpointId: string; deliveryId: string }) =>
		api.post<QueuedWebhookDelivery>(
			`/platform/webhooks/${vars.endpointId}/deliveries/${vars.deliveryId}/redeliver`,
		),
	onSuccess: invalidate,
});
